/**
 * 配送物の受領状態
 */
export const ReceiveStatus = {
    /**
     * 配送済み
     */
    Received: "Received",
    /**
     * 荷物搭載済み
     */
    Loaded: "Loaded",
    /**
     * 搭載準備中
     */
    Preparation: "Preparation",
    /**
     * @deprecated
     */
    NotReceived: "NotReceived",
    /**
     * 集荷待ち
     */
    WaitingForPickup: "WaitingForPickup",
    /**
     * キャンセル
     */
    Cancel: "Cancel",
    /**
     * 出発ポートに向けて出発
     */
    DepartForPort: "DepartForPort",
} as const;
export type ReceiveStatus = typeof ReceiveStatus[keyof typeof ReceiveStatus];